import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const fileCancelPendingUploadMutationAtom = createMutationAtomFactory(
  'files.cancelPendingUpload',
  ({ fileId }: { fileId: string }) => ({
    filesCancelPendingUpload: {
      __args: {
        fileID: fileId,
      },
      success: true,
    },
  }),
);
